<template>
  <el-cascader
    style="width: 200px"
    size="small"
    v-model="data"
    v-bind="$attrs"
    :options="selectOptions"
    @change="handleChange"
    :props="{
      children: 'child',
      value: 'code',
      label: 'name'
    }"
    clearable
  >
  </el-cascader>
</template>

<script>
export default {
  props: {
    value: {
      type: [Array, String]
    },
    query: {
      type: String,
      default: ''
    }
  },
  created() {
    if (this.query) {
      this.$ajax.get(this.query).then((data) => {
        this.selectOptions = data.data
      })
    }
  },
  data() {
    return {
      data: this.value,
      selectOptions: []
    }
  },
  watch: {
    value(val) {
      this.data = val
    }
  },
  methods: {
    handleChange(val) {
      this.$emit('input', val)
      this.$emit('getNet', getNetParams(val, this.selectOptions))
    }
  }
}
function getNetParams(val, arr) {
  let first = val[0]
  let cur = arr.filter((el) => el.code === first)[0]
  if (cur && Array.isArray(cur.child)) {
    let second = val[1]
    let arr = cur.child
    let tem = arr.filter((el) => el.code == second)[0]
    if (tem) {
      return tem.networking
    }
  }
  return ''
}
</script>
